import { render } from "./Statistics.vue?vue&type=template&id=4100993a&scoped=true"
import script from "./Statistics.js?vue&type=script&lang=js"
export * from "./Statistics.js?vue&type=script&lang=js"

import "./Statistics.scss?vue&type=style&index=0&id=4100993a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4100993a"]])

export default __exports__